export default __webpack_public_path__ + "img/7cb1c6bbc5315f6749aa238cf7aa99f9.png";